<template>
  <form @submit.prevent="holidayAction">
    <div class="mb-3">
      <label>Holiday Name</label>
      <input
          v-model="holiday.publicHolidayName"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.holiday.publicHolidayName.$error,
          }"
      />
      <p
          v-for="error of v$.holiday.publicHolidayName.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Holiday Date</label>
      <date-picker v-model="holiday.publicHolidayDate" class="date-picker-height-3" format="YYYY-MM-DD" valueType="format" :class="{
                        'is-invalid': v$.holiday.publicHolidayDate.$error,
                  }"></date-picker>
      <p
          v-for="error of v$.holiday.publicHolidayDate.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in SettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="SettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";
import moment from 'moment'

export default {
name: "public-holiday-form",
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      holiday: this.selected_holiday,
    }
  },
  props: {
    selected_holiday: {
      type: Object,
      default(){
        return{
          publicHolidayName: '',
          publicHolidayDate: '',
        }
      }
    },
    button_text: {type: String}
  },
  computed: {
    ... mapGetters({
      SettingsLoading: 'settings/settingsLoading',
      SettingsErrors: 'settings/settingsErrors'
    }),
  },
  validations () {
    return {
      holiday: {
        publicHolidayName: {required},
        publicHolidayDate: {required},
      }
    }
  },
  methods: {
    async holidayAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        publicHolidayName: this.holiday.publicHolidayName,
        publicHolidayDate: moment(this.holiday.publicHolidayDate).format('YYYY-MM-DD')
      }

      this.$emit('holidayAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
